const getObjFromQueryString = (str) => {
  const urlParams = new URLSearchParams(str);
  const result = {};
  for (const pair of urlParams.entries()) {
    result[pair[0]] = pair[1];
  }
  return result;
};
const regexes = [
  {
    regex: /-s([A-Za-z0-9._-]{1,20})\.html/,
    pathname: "/products/[sku]",
    paramName: "sku"
  },
  {
    regex: /--s([A-Za-z0-9._-]{1,20})/,
    pathname: "/products/[sku]",
    paramName: "sku"
  },
  {
    regex: /-(.*)\.cat/,
    pathname: "/categories/[categoryId]",
    paramName: "categoryId"
  },
  {
    regex: /-c([0-9]{1,})/,
    pathname: "/categories/[categoryId]",
    paramName: "categoryId"
  },
  {
    regex: /-cat\.(.*)/,
    pathname: "/block-categories/[categoryId]",
    paramName: "categoryId"
  },
  {
    regex: /-sel\.(.*)/,
    pathname: "/sellers/[sellerId]",
    paramName: "sellerId"
  },
  {
    regex: /-brand\.(.*)/,
    pathname: "/brands/[brandId]",
    paramName: "brandId"
  }
];
const extractFromPath = (path) => {
  for (const reg of regexes) {
    const matchResult = path.match(reg.regex);
    if (matchResult) {
      return {
        pathname: reg.pathname,
        query: {
          [reg.paramName]: matchResult[1]
        }
      };
    }
  }
  return path;
};
function getUrlObject(href) {
  try {
    return new URL(href);
  } catch (e) {
    if (!href.startsWith("/")) {
      href = "/" + href;
    }
    return new URL(`https://fake.com${href}`);
  }
}

export { extractFromPath, getObjFromQueryString, getUrlObject };
